import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { countryName } from 'modules/core/lib/countryList'
import i18n from 'modules/core/lib/i18n'

const nationalitiesFilter = (
  source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>,
  nationalities: string[]
) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.nationality'),
    path: 'nationality',
    identifier: 'nationalities',
    type: FilterType.String,
    default: false,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: nationalities.map((nationality) => ({
          label: countryName(nationality),
          value: nationality,
        })),
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'nationalities',
        value,
      })
    },
  })
}

export default nationalitiesFilter
